// extracted by mini-css-extract-plugin
export default {"wrapper":"PlusMinusInput_wrapper__0XRXt","dirty":"PlusMinusInput_dirty__-nf7o","quantity-loading":"PlusMinusInput_quantity-loading__-rzro","button":"PlusMinusInput_button__GpdM2"};